import _ from "lodash";

const FavoriteTreatmentUtils = {
  getCachedFavorites: () => {
    const cached = localStorage.getItem("favourites");
    if (!cached) return null;
    return JSON.parse(cached);
  },
  setCachedFavorites: (favourites) => {
    localStorage.setItem("favourites", JSON.stringify(favourites));
  },
  getSpecialityCode: () => {
    return localStorage.getItem("specialityCode");
  },

  getSelectedCodes: (favoritesData) => {
    const codes = [];
    _.forEach(favoritesData, (item, index) => {
      if (item.selected) {
        codes.push(index);
      }
    });
    return codes;
  },
};

export default FavoriteTreatmentUtils;
